var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CHeaderLayout',{on:{"show-account-menu":function($event){return _vm.$emit('show-account-menu')}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h1',[_vm._v("Appearance")])]},proxy:true}])},[_vm._v(" "),_c('main',{staticClass:"organization-appearance"},[_c('COrganizationAppearanceView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }